import { ReducerFunctions } from "../../config/helper";
import {
  Customer,
  Customers,
  GetMarketing,
  GetProdsFromExcel,
  Marketing,
  Orders,
  Products,
  SyncOmniData,
  UploadExcel,
  Origins
} from "./Action";

export const orders_reducer = ReducerFunctions(Orders, {});
export const origins_reducer = ReducerFunctions(Origins, {});
export const products_reducer = ReducerFunctions(Products, {});
export const sync_data_reducer = ReducerFunctions(SyncOmniData, {});
export const marketing_reducer = ReducerFunctions(Marketing, {});
export const get_marketing_reducer = ReducerFunctions(GetMarketing, {});
export const customers_reducer = (state = {}, action) => {
  let data = Array.isArray(action?.payload)
    ? [...action?.payload]
    : typeof action?.payload === "string"
      ? action?.payload
      : { ...action?.payload };
  switch (action?.type) {
    case Customers.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Customers.SUCCESS: {
      return {
        ...state,
        data,
        dataCopy: data,
        loading: false,
        success: true,
      };
    }
    case Customers.CHANGED: {
      let data1 = []
      if (action.filter && state?.dataCopy) {
        data1 = state?.dataCopy?.filter(ele => ele.name?.toLowerCase()?.includes(action.searchKey?.toLowerCase()) || ele.phone?.toLowerCase()?.includes(action.searchKey?.toLowerCase()) || ele.email?.toLowerCase()?.includes(action.searchKey?.toLowerCase()))
      }
      console.log("data1", data1);
      return {
        ...state,
        data: data1,
      };
    }
    case Customers.FAILED:
      return {
        ...state,
        data,
        loading: false,
        success: false,
      };
    case Customers.RESET:
      return {
        loading: false,
      };

    default:
      return state;
  }
};
export const customer_reducer = ReducerFunctions(Customer, {});
export const get_prods_from_excel_reducer = ReducerFunctions(
  GetProdsFromExcel,
  {}
);
export const upload_excel_reducer = ReducerFunctions(UploadExcel, {});
